<div
  bsModal
  tabindex="-1"
  aria-labelledby="pop-acelera-mais"
  class="body"
>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          (click)="onClickClose()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="container-content">
        <div class="first-section">
          <div>
            <h1>Atenção!</h1>
            <h2>Lojistas e vendedores,</h2>
            <h3>
              façam parte do clube Omni e acelere seus resultados com a campanha
              Omni Acelera+ 2.0!
            </h3>
          </div>
          <img
            src="assets/images/acelera-mais/acelera-mais-campanha-2.png"
            alt="banner-acelera-mais"
            width="218px"
          />
        </div>
        <div class="line"></div>
        <h4>Benefícios exclusivos estão esperando por você!</h4>
        <section class="second-section">
          <div>
            <img
              src="assets/images/acelera-mais/acelera-mais-icon-plus.svg"
              alt="icone-adição-acelera-mais"
              width="36px"
            />
            <span class="text-highlight"> Campanhas </span>
          </div>
          <div>
            <img
              src="assets/images/acelera-mais/acelera-mais-icon-plus.svg"
              alt="icone-adição-acelera-mais"
              width="36px"
            />
            <span class="text-highlight"> Missões </span>
          </div>
          <div>
            <img
              src="assets/images/acelera-mais/acelera-mais-icon-plus.svg"
              alt="icone-adição-acelera-mais"
              width="36px"
            />
            <span class="text-highlight"> Premiações </span>
          </div>
        </section>
        <section class="third-section">
          <a (click)="redirectUser()" onKeyPress="redirectUser()">
            <img
              src="assets/images/acelera-mais/acelera-mais-button-download.svg"
              alt="icone-download-acelera-mais"
              width="463px"
              class="icon-download"
            />
          </a>
        </section>
        <h5>
          Mantenha seu <b>cadastro atualizado</b> para não perder nenhuma
          oportunidade.
        </h5>
      </div>
      <section class="fourth-section">
        <div class="display-flex-column gap-8">
          <div class="whatsapp-information">
            <span class="icon_whatapp_full"></span>
            <span class="text-informative-whatsapp">
              Dúvidas ou dificuldades?
            </span>
          </div>
          <div class="display-flex-column">
            <span class="text-informative">
              Entre em contato com nossa central pelo WhatsApp:
            </span>
            <span class="text-informative">
              <b>11 2886-6679 </b> (somente mensagens, das 9h às 18h).
            </span>
          </div>
        </div>
        <img
          src="assets/images/acelera-mais/acelera-mais-clube-omni.svg"
          alt="banner-acelera-mais-clube-omni"
          width="175px"
        />
      </section>
    </div>
  </div>
</div>
